import React from 'react';
export default () => (
	<div className='Mid1'>
		<h4>
		We have the Solution for you.
		</h4>
	</div>
);
